export default __webpack_public_path__ + "static/media/pace.eaca48dc.png";